import { Alignment, EditAttributes } from "design-system/types/types";
import { ReactNode } from "react";
import cn from "clsx";

export interface RichTextProps {
  useDropCap?: boolean;
  children?: ReactNode;
  align?: Alignment;
  editAttribute?: EditAttributes;
}

export function RichText({
  useDropCap: useDropCapRaw,
  children,
  align = "center",
  editAttribute,
}: RichTextProps) {
  const useDropCap = useDropCapRaw === true ? true : undefined;
  const hideDropCap = useDropCapRaw === false ? true : undefined;
  return (
    <div
      className={cn(
        `hbs-global-align-${align} hbs-rich-text`,
        useDropCap && "hbs-use-dropcap",
        hideDropCap && "hbs-hide-dropcap",
      )}
      {...editAttribute}
    >
      {children}
    </div>
  );
}
